import * as React from "react";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import {SessionArea} from "./SessionArea";
import {NewSession} from "../types/sessionsstate";
import {AuthScope, UserInfo} from "../types/userstate";
import {landingMap, LandingNames} from "./landings";
import {LANDING} from "../utils/constants";
import {GetTokenSilentlyOptions, useAuth0, User} from "@auth0/auth0-react";
import {KApp, KErrorPage, Translate} from "@kopjra/uikit";
import {ProtectedRoute, Routes as R} from "../utils/router";
import {initGetTokenFunction} from "../api";
import {useGetUserInfo} from "../api/user.ts";
import {BigWaiter} from "./BigWaiter.tsx";
import {Login} from "./Login.tsx";
import {Toolbar} from "./Toolbar.tsx";
import {AcquisitionArea} from "./AcquisitionArea.tsx";
import {DetailBrowser} from "./DetailBrowser.tsx";
import {UserProfile} from "./UserProfile.tsx";
import {Users} from "./admin/Users.tsx";
import {Sessions} from "./admin/Sessions.tsx";
import {CreateSession} from "./CreateSession.tsx";
import {Acquisition} from "./Acquisition.tsx";

export interface StateProps {
    session?: NewSession;
    authChecked: boolean;
    userInfo?: UserInfo;
    openedModal: boolean;
}

export interface DispatchProps {
    onCancelSession: () => void;
    onGetUserInfo: (auth0User?: User) => Promise<void>;
}

export type Props = StateProps & DispatchProps;

export let getToken: (o?: GetTokenSilentlyOptions) => Promise<unknown>;

export const App: React.FC = () => {
    const {getAccessTokenSilently, isLoading} = useAuth0();
    initGetTokenFunction(getAccessTokenSilently);
    const {data: userInfo, isLoading: userInfoLoading} = useGetUserInfo();
    const location = useLocation();

    return (userInfoLoading || isLoading) ? (
        <BigWaiter/>
    ) : (
        <KApp>
            {location.pathname === R.routeHome || location.pathname === "" ? null : <Toolbar/>}
            <Routes>
                {LANDING === LandingNames.KOPJRA_LANDING ? (
                    <Route path={R.routeHome} element={<Navigate to={R.routeSessions}/>}/>
                ) : (
                    <Route path={R.routeHome} element={userInfo ? <Navigate to={R.routeSessions}/> : landingMap[LANDING]}/>
                )}
                <Route path={R.routeSessions} element={<ProtectedRoute Component={SessionArea}/>}/>
                <Route path={R.routeMy_sessions} element={<ProtectedRoute Component={AcquisitionArea}/>}/>
                <Route path={R.routeA_session} element={<ProtectedRoute Component={DetailBrowser}/>}/>
                <Route path={R.routeUser_account} element={<ProtectedRoute Component={UserProfile}/>}/>
                <Route path={R.routeAdmin} element={<ProtectedRoute Component={() => <Navigate to={R.routeAdmin_users}/>} allowedScopes={[AuthScope.SUPERADMIN, AuthScope.ADMIN]}/>}/>
                <Route path={R.routeAdmin_users} element={<ProtectedRoute Component={Users} allowedScopes={[AuthScope.SUPERADMIN, AuthScope.ADMIN]}/>}/>
                <Route path={R.routeAdmin_sessions} element={<ProtectedRoute Component={Sessions} allowedScopes={[AuthScope.SUPERADMIN, AuthScope.ADMIN]}/>}/>
                <Route path={R.routeNew_session} element={<ProtectedRoute Component={CreateSession} />}/>
                <Route path={R.routeNavigate} element={<ProtectedRoute Component={Acquisition} />}/>


                <Route path={R.routeLogin} element={userInfo ? <Navigate to={R.routeSessions}/> : <Login/>}/>
                <Route path={R.routeAll} element={<KErrorPage title={<Translate i18nKey="error.page"/>} code={"404"} message={<Translate i18nKey="error.notFound"/>}/>}/>
            </Routes>
            {/*{location.pathname === Routes.HOME || hasSessionId(location) || location.pathname === Routes.NEW_SESSION || location.pathname === "" ? null : <KStandardFooter/>}*/}
        </KApp>
    );
};
